import { SetNavbarStickyAction } from '../actions/navbarActions'

export type NavbarState = {
  sticky: boolean
  force_refresh: boolean
}

const initialState: NavbarState = {
  sticky: false,
  force_refresh: false,
}

export type NavbarRootState = {
  navbar: NavbarState
}

const navbarReducer = (
  state = initialState,
  action: SetNavbarStickyAction,
): NavbarState => {
  switch (action.type) {
    case 'SET_NAVBAR_STICKY':
      return {
        ...state,
        sticky: action.sticky,
      }
    default:
      return state
  }
}

export default navbarReducer
